<template>
	<div>
		<v-dialog v-model="dialog_due_days" no-click-animation persistent scrollable transition="dialog-bottom-transition">
	      <v-card flat>
	      	<!-- <v-card-title noshadow nopadding>
        		<v-subheader full-width>Due Days</v-subheader>
        	</v-card-title> -->

	        <v-card-text dialog-card-content>
	            <v-layout wrap>
	            	<v-form data-vv-scope="fields" full-width>

			            <v-flex xs12 sm12 md12 form-item>
			               <v-text-field 
			               		label="Enter Due Days" 
			               		placeholder=" " 
			               		type="number" 
			               		v-model.number="dueDays"
			               		v-validate="'required'" 
		               			data-vv-name="duedays" 
		               			data-vv-as="due days" 
		               			:error-messages="errors.collect('fields.duedays')">
			               	</v-text-field>
			            </v-flex>

		            </v-form>
	            </v-layout>

	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="fn_clearFilter">Clear</v-btn>
	          <v-btn color="blue darken-1" flat @click.native="fn_checkValidations">Done</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_due_days: false,
            dueDays:null
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.errors.clear('fields');
			// this.fn_getTaxRate();
			// this.taxRate = this.$parent.compTaxRate.value;
			this.dialog_due_days = true;
            this.dueDays = this.$parent.selectedDueDays;
		},
		closeDialogWeb: function () {
			this.dialog_due_days = false;
		},
		fn_clearFilter: function(){
			this.$parent.fn_updateDueDate(null);
		},
		// fn_getTaxRate: function(){
		// 	for(let i=0; i<this.$parent.compTaxRateList.length; i++){
	 //          if(this.$parent.compTaxRateList[i].value == this.$parent.compTaxRate.value){
	 //            this.taxName = this.$parent.compTaxRateList[i].name;
	 //            break;
	 //          }
	 //        }
	 //    },
		fn_checkValidations: function () {
			// let valueObj = {};
			// valueObj.taxRate = this.$parent.fn_getTaxRate() == 'Custom' ? this.taxRate : this.$parent.compTaxRate;
			// let taxRate = this.taxName == 'custom' ? this.taxRate : this.$parent.compTaxRate.value;

			this.$validator.validateAll('fields').then((result) => {
				if(result){
					if(this.dueDays)
						this.$parent.fn_updateDueDate(this.dueDays);
					else
						this.showToast('Please add due date');
				}
		    });

			// let self = this;

			// let customError = false;

			// if(!this.$parent.Form.addressData.isBillingAddress && !this.$parent.Form.addressData.isShippingAddress){
			// 	customError = true;
			// }

			// this.$validator.validateAll('fields').then((result) => {
			// 	if(result && !customError){
			// 		this.saveAddress(this.$parent.Form.addressData);
			// 	}
			// 	else{
			// 		let cardElement = document.querySelector('.address .v-card__text');
			// 		let errorElement = document.querySelectorAll('.address .v-card__text .error--text')[0];
			// 		cardElement.scrollTop = errorElement.offsetTop - 100;
			// 	}
		 //    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_due_days_filter.vue